module.exports = __webpack_public_path__ + "static/media/app-mockup2.f734849a.png";